// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__DwwVV","description":"PatientConsentPreview_description__2yKGR"};